<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <!-- profil -->
    <div class="user-info" @click="goToProfil()">
      <div class="profile row">
        <div class="col-xs-12 col-md-6 col-lg-4 col-4 image_profile">
          <img v-lazy="this.$store.getters.auth.image.cropped" alt="" />
        </div>
        <div
          v-if="$store.getters.marchand"
          class="col-xs-12 col-md-6 col-8 col-lg-8 text-left text-profile"
        >
          <span
            class="designation"
            v-b-tooltip.hover
            :title="
              $store.getters.auth._first_name && $store.getters.auth._last_name
                ? $store.getters.auth._first_name +
                  ' ' +
                  $store.getters.auth._last_name
                : $store.getters.auth._email
            "
            >{{
              setTextToUpperCase(
                limiText(
                  $store.getters.auth._first_name &&
                    $store.getters.auth._last_name
                    ? $store.getters.auth._first_name +
                        " " +
                        $store.getters.auth._last_name
                    : $store.getters.auth._email,
                  15
                )
              )
            }}</span
          ><br />
          <span class="role-profile">
            <span v-if="$store.getters.marchand">
              <v-chip
                v-b-tooltip.hover
                :title="$t('account_status_valid')"
                v-if="$store.getters.marchand._valide"
                color="#CEEDDF"
                style="height: 25px !important"
                text-color="#31AF60"
                ><strong class="success-text">
                  <v-icon color="#31AF60" style="margin-top: -3px" small
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <span class="text-uppercase"> actif </span></strong
                >
              </v-chip>
              <v-chip
                v-else
                v-b-tooltip.hover
                :title="$t('account_status_invalid')"
                color="#FFC961"
                text-color="#4a4a4a"
                ><strong
                  class="warning-text text-uppercase"
                  style="
                    height: 25px !important;
                    line-height: 28px;
                    color: #fff;
                  "
                >
                  <v-icon color="orange" style="margin-top: -3px" small
                    >mdi-minus-circle</v-icon
                  >
                  inactif</strong
                >
              </v-chip>
            </span>
          </span>
        </div>
        <div
          v-else
          class="col-xs-12 col-md-6 col-8 col-lg-8 text-left text-profile"
        >
          <span class="designation">{{
            setTextToUpperCase(
              limiText(getUserNames() || $store.getters.auth._email, 10)
            )
          }}</span
          ><br />
          <span class="role-profile">
            {{
              setTextToUpperCase(limiText($store.getters.auth.role._label, 10))
            }}</span
          >
        </div>
      </div>
    </div>
    <!-- End Of Profil -->
    <!-- Nav Menu List -->
    <ul class="nav" id="menuNav">
      <!--main pages start-->
      <li
        v-if="$can('browse', 'Dashboard')"
        class="nav-item"
        :class="[currentPage === 'dashboard' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'dashboard' }">
          <i class="mdi mdi-view-dashboard menu-icon"></i>
          <span class="menu-title">{{ $t("menus.dashboard") }}</span>
        </router-link>
      </li>
      <li
        v-if="$can('browse', 'Users')"
        class="nav-item"
        :class="[currentPage === 'users' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'users' }">
          <i class="mdi mdi-account-group menu-icon"></i>
          <span class="menu-title">{{ $t("menus.users") }}</span>
        </router-link>
      </li>

      <li
        v-if="$can('browse', 'Roles')"
        class="nav-item"
        :class="[currentPage === 'roles' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'roles' }">
          <i class="mdi mdi-account-convert menu-icon"></i>
          <span class="menu-title">{{ $t("menus.roles") }}</span>
        </router-link>
      </li>

      <li
        v-if="$can('browse', 'Intramwallets')"
        class="nav-item"
        :class="[currentPage === 'intramwallets' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'intramwallets' }">
          <i class="mdi mdi-wallet-outline menu-icon"></i>
          <span class="menu-title">{{ $t("menus.intramwallets") }}</span>
        </router-link>
      </li>
      <li v-if="$can('browse', 'Administration')" class="nav-item">
        <a
          class="nav-link"
          data-toggle="collapse"
          aria-expanded="false"
          href="#layoutsSubmenu"
          aria-controls="layoutsSubmenu"
          style="background: transparent !important; color: #0d0a0a !important"
        >
          <i class="mdi mdi-cog-refresh menu-icon"></i>
          <span class="menu-title">{{ $t("menus.administration") }}</span>
          <i class="mdi mdi-chevron-down menu-arrow"></i>
        </a>
        <div class="collapse" id="layoutsSubmenu">
          <ul class="nav flex-column sub-menu">
            <li
              v-if="$can('browse', 'Langues')"
              class="nav-item"
              :class="[currentPage === 'langues' ? 'active' : '']"
            >
              <router-link class="nav-link" :to="{ name: 'langues' }">
                <i class="mdi mdi-translate menu-icon"></i>
                {{ $t("menus.langues") }}
              </router-link>
            </li>
            <li
              v-if="$can('browse', 'Countries')"
              class="nav-item"
              :class="[currentPage === 'countries' ? 'active' : '']"
            >
              <router-link class="nav-link" :to="{ name: 'countries' }">
                <i class="mdi mdi-flag menu-icon"></i>
                {{ $t("menus.countries") }}
              </router-link>
            </li>
            <li
              v-if="$can('browse', 'Devises')"
              class="nav-item"
              :class="[currentPage === 'devises' ? 'active' : '']"
            >
              <router-link class="nav-link" :to="{ name: 'devises' }"
                ><i class="mdi mdi-currency-sign menu-icon"></i>
                {{ $t("menus.devises") }}
              </router-link>
            </li>
            <li
              v-if="$can('browse', 'Meanspaiments')"
              class="nav-item"
              :class="[currentPage === 'meanspaiments' ? 'active' : '']"
            >
              <router-link class="nav-link" :to="{ name: 'meanspaiments' }"
                ><i class="mdi mdi-credit-card menu-icon"></i>
                {{ $t("menus.means_of_paiment") }}
              </router-link>
            </li>

            <li
              v-if="$store.getters.auth.role._code === 'admin'"
              class="nav-item"
              :class="[
                currentPage === 'usersmeanspaiementconfirmation'
                  ? 'active'
                  : '',
              ]"
            >
              <router-link
                class="nav-link"
                :to="{ name: 'usersmeanspaiementconfirmation' }"
                ><i class="mdi mdi-check-decagram menu-icon"></i>
                {{ $t("menus.usersmeanspaiementconfirmation") }}
              </router-link>
            </li>

            <li
              v-if="$can('browse', 'Templates')"
              class="nav-item"
              :class="[currentPage === 'templates' ? 'active' : '']"
            >
              <router-link class="nav-link" :to="{ name: 'templates' }"
                ><i class="mdi mdi-file menu-icon"></i>
                {{ $t("menus.template") }}
              </router-link>
            </li>
          </ul>
        </div>
      </li>
      <li v-if="$can('browse', 'Marchands')" class="nav-item">
        <a
          class="nav-link"
          data-toggle="collapse"
          href="#layoutsSubmenu2"
          aria-expanded="false"
          aria-controls="layoutsSubmenu2"
          style="background: transparent !important; color: #0d0a0a !important"
        >
          <i
            style="color: #0d0a0a !important"
            class="mdi mdi-shopping menu-icon"
          ></i>
          <span style="color: #0d0a0a !important" class="menu-title">{{
            $t("menus.marchands")
          }}</span>
          <i style="" class="mdi mdi-chevron-down menu-arrow"></i>
        </a>
        <div class="collapse" id="layoutsSubmenu2">
          <ul class="nav flex-column sub-menu">
            <li
              v-if="$can('browse', 'Categorymarchands')"
              class="nav-item"
              :class="[currentPage === 'categories_marchands' ? 'active' : '']"
            >
              <router-link class="nav-link" :to="{ name: 'categorymarchands' }"
                ><i class="mdi mdi-archive menu-icon"></i
                >{{ $t("menus.categories") }}
              </router-link>
            </li>
            <li
              v-if="$can('browse', 'Statemarchands')"
              class="nav-item"
              :class="[currentPage === 'states_marchands' ? 'active' : '']"
            >
              <router-link class="nav-link" :to="{ name: 'statemarchands' }"
                ><i class="mdi mdi-drawing menu-icon"></i
                >{{ $t("menus.states") }}
              </router-link>
            </li>
            <li
              v-if="$can('browse', 'Marchands')"
              class="nav-item"
              :class="[currentPage === 'list_marchands' ? 'active' : '']"
            >
              <router-link class="nav-link" :to="{ name: 'marchands' }"
                ><i class="mdi mdi-view-list menu-icon"></i
                >{{ $t("menus.listes") }}
              </router-link>
            </li>
          </ul>
        </div>
      </li>
      <!-- <li v-if="this.$store.getters.marchand" class="nav-item" :class="[currentPage==='reversements.configs'?'active':'']">
             <router-link class="nav-link"  :to="{name:'reversements.configs'}">
                 <i class="mdi mdi-cash-refund menu-icon"></i>
                 <span class="menu-title">{{$t('menus.reversements_configs')}}</span>
             </router-link>
         </li>-->
      <!-- <li v-if="($store.getters.marchand && $store.getters.marchand._env==='live')" class="nav-item" :class="[currentPage==='recharges'?'active':'']">
            <router-link class="nav-link"  :to="{name:'recharges'}">
                <i class="mdi mdi-credit-card-check menu-icon"></i>
                <span class="menu-title">{{$t('menus.recharges')}}</span>
            </router-link>
        </li>-->
      <!--<li v-if="($can('browse', 'Adminreversements'))" class="nav-item" :class="[currentPage==='adminreversements.configs'?'active':'']">
            <router-link class="nav-link"  :to="{name:'adminreversements.configs'}">
                <i class="mdi mdi-cash-refund menu-icon"></i>
                <span class="menu-title">{{$t('menus.reversements_configs')}}</span>
            </router-link>
        </li>-->

      <li
        class="nav-item"
        :class="[currentPage === 'transactions' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'transactions' }">
          <i class="mdi mdi-cash-multiple menu-icon"></i>
          <span class="menu-title">{{ $t("menus.transactions") }}</span>
        </router-link>
      </li>
      <li
        v-if="marchandexiste"
        class="nav-item"
        :class="[currentPage === 'usermeanspaiments' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'usermeanspaiments' }">
          <i class="mdi mdi-credit-card menu-icon"></i>
          <span class="menu-title">{{ $t("menus.usermeanspaiments") }}</span>
        </router-link>
      </li>
      <li
        v-if="$store.getters.auth.role._code === 'admin'"
        class="nav-item"
        :class="[currentPage === 'list_newsletters' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'list_newsletters' }">
          <i class="mdi mdi-email-fast-outline menu-icon"></i>
          <span class="menu-title">{{ $t("menus.newsletters") }}</span>
        </router-link>
      </li>
      <li
        class="nav-item"
        :class="[currentPage === 'settings' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'settings' }">
          <i class="mdi mdi-cog menu-icon"></i>
          <span class="menu-title">{{ $t("menus.settings") }}</span>
        </router-link>
      </li>
      <li class="nav-item">
        <a @click.prevent="logout()" class="nav-link" href="#">
          <i class="mdi mdi-logout menu-icon"></i>
          <span class="menu-title">{{ $t("menus.logout") }}</span>
        </a>
      </li>
    </ul>
    <div class="nav-category topHead text-center pt-2">
      <img v-lazy="'/images/logo_large_white.png'" class="logoDash" alt="" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "admin-sidebar",
  data() {
    return {
      profileView: false,
      switch1: false,
      switch2: true,
      marchandexiste: false,
      user: JSON.parse(localStorage.getItem("user")),
      allmarchands: [],
      checked:
        this.$store.getters.marchand &&
        this.$store.getters.marchand._env === "live"
          ? true
          : false,
    };
  },
  computed: {
    currentPage() {
      return this.$route.name;
    },
    ...mapState("marchands/", ["marchandu"]),
  },
  mounted() {
    if (this.$store.getters.marchand) {
      this.marchandexiste = true;
      this.$store.dispatch("marchands/getMarchandUser");
      this.$store.dispatch("marchands/getMarchandByUser").then((response) => {
        this.allmarchands =
          response && response.data && response.data.marchandu
            ? response.data.marchandu
            : {};
      });
    }
  },
  methods: {
    newMarchand() {
      this.$router.push({ name: "newAccountMarchand" });
    },
    goToProfil() {
      if (this.$router.currentRoute !== "/settings") {
        this.$router.push("/settings");
      }
    },
    setProfileVisibility: function () {
      !this.profileView
        ? (this.profileView = true)
        : (this.profileView = false);
    },
    getUserNames() {
      let names = undefined;
      if (
        !(
          this.$store.getters.auth._first_name &&
          this.$store.getters.auth._last_name
        )
      ) {
        if (!this.$store.getters.auth._first_name) {
          if (this.$store.getters.auth._last_name) {
            names = this.$store.getters.auth._last_name;
          }
        } else {
          names = this.$store.getters.auth._first_name;
        }
      } else {
        names =
          this.$store.getters.auth._first_name +
          " " +
          this.$store.getters.auth._last_name;
      }
      return names;
    },
  },
};
</script>

<style scoped>
.menuable__content__active {
  left: 0 !important;
  min-width: 240px !important;
}

.v-list-item__title span {
  font-weight: normal !important;
}

.no-uppercase {
  text-transform: none;
}

.theme--light.v-application {
  background: transparent;
}

#sidebar {
  box-shadow: 0 6px 15px 0 rgba(207, 211, 218, 0.35);
  border-color: #29b3a6;
  position: fixed;
  min-height: 100vh;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 20px;
}

.sidebar .nav {
  /* max-height: 80vh !important;
  min-height: 80vh !important; */
  overflow-y: auto;
}
#menuNav {
  min-height: 80vh !important;
}

.sidebar .nav::-webkit-scrollbar {
  border: none;
  box-shadow: none;
}

.sidebar .nav::-webkit-scrollbar-track {
  border: none;
  box-shadow: none;
}

.sidebar .nav::-webkit-scrollbar-track:active,
.sidebar .nav::-webkit-scrollbar-track:focus {
  border: none;
  box-shadow: none;
}

.sidebar .nav::-webkit-scrollbar-track-piece {
  border: none;
  box-shadow: none;
}

.sidebar .nav::-webkit-scrollbar-thumb {
  border-radius: 50px;
  background-image: linear-gradient(#f8f8f8, #29b3a6) !important;
  border: none;
}

ul.nav {
  padding-left: 0;
}

.nav-category {
  background: #29b3a6;
  box-shadow: 0 6px 15px 0 rgba(207, 211, 218, 0.35);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.topHead {
  border: none;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 7vh;
}

.logoDash {
  width: 70px;
}

.user-info {
  border-bottom: 2px solid #f8f8f8;
  text-align: center;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  height: 12vh !important;
}

.user-info p {
  margin-top: 10px;
}

.logouPanel {
  margin-top: 10px;
}

.secondProfile {
  color: #fff;
  cursor: pointer;
}

.imgProfileSecond {
  height: 40px;
  width: 40px;
  border: 2px solid #fff;
  border-radius: 100%;
  margin-right: 10px;
}

.user-info {
  transition-duration: 200ms;
  border-bottom: 10px solid #29b3a6;
  margin-bottom: 10px;
  cursor: pointer;
}

/* .user-info:hover{
      color: #fff;
      background: #29B3A6;
      border-bottom: 0px solid #006958;
  } */
.nav-link:hover {
  color: #006958;
}

.fa-angle-up:before {
  content: "\f106";
}

.profileDown {
  position: absolute;
  right: 10px;
  color: #fff;
  top: 10px;
  cursor: pointer;
}

.sidebar-dark .sidebar .nav.sub-menu .nav-item .nav-link {
  color: #000;
}

.text-profile {
  padding: 20px 0;
}

.image_profile {
  text-align: center;
  font-weight: bold;
}

.image_profile img {
  width: 0;
}

.role-profile {
  font-size: 10pt;
  color: #d21d19;
}

.sidebar-dark .sidebar .nav .nav-item .nav-link i {
  font-size: 15pt;
}

.sidebar-icon-only:not(.sidebar-expanded)
  .sidebar
  .nav
  .nav-item.hover-open
  .nav-link
  .menu-title {
  background: #fff;
}

@media (max-width: 991px) {
  #sidebar {
    position: absolute;
    height: 100vh;
  }

  .sidebar {
    min-height: 100vh;
  }
}
</style>
